const listeners = new Set<(reason: 'refresh' | 'clear') => void>();

/** Successful local edits and auth cleanup discard all search data in the mounted shell. */
export function invalidateGlobalSearch() {
  listeners.forEach((listener) => listener('refresh'));
}

export function clearGlobalSearch() {
  listeners.forEach((listener) => listener('clear'));
}

export function subscribeGlobalSearchInvalidation(listener: (reason: 'refresh' | 'clear') => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function affectsGlobalSearch(method: string | undefined, url: string | undefined) {
  return Boolean(
    method &&
    !['get', 'head', 'options'].includes(method.toLowerCase()) &&
    url &&
    /^\/(?:drivers|karts|data-files|teams|telemetry|auth\/me|admin\/(?:circuits|users|teams))(?:[/?]|$)/.test(
      url,
    ),
  );
}
